
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';



const TermsAndConditions = () => {
    const navigate = useNavigate();
    const [termsAndConditions, setTermsAndConditions] = useState(null);

    useEffect(() => {
        if (!localStorage.getItem('@roampays-user')) {
            navigate("/login")
        }
        getTermsAndConditions();


    }, []);




    const getTermsAndConditions = async () => {

        axios.get(process.env.REACT_APP_API_URL + "/get-terms-and-conditions", {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {
                if (response?.data?.status) {


                    setTermsAndConditions(response?.data?.terms_and_conditions);




                }
            })
            .catch(function (error) {

                Swal.fire({ icon: "error", title: "Error", text: error.message });

            });
    }



    const backToProfile = async (e) => {

        navigate("/profile");


    };

    return (


        <>


<div className="title-box">

<div className="flex-equal justify-content-start " >
    <button className="btn btn-link fs-12 d-flex fd-row align-items-center" onClick={backToProfile} >

        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.69765 6.99997L8.68205 4.01557L7.65085 2.98438L3.63525 6.99997L7.65085 11.0156L8.68205 9.98438L5.69765 6.99997Z" fill="white" />
        </svg>
        <label >Back</label>

    </button>

</div>
<h3 className="flex-equal justify-content-center fs-32 fs-helvetica color-white">Terms & Conditions</h3>
<div className="flex-equal justify-content-end" ></div>

</div>

          

            <div className="box" >


                <div className="card color-white p-20" >

                    <div dangerouslySetInnerHTML={{ __html: termsAndConditions }} />



                </div>


            </div>





        </>


    );
};

export default TermsAndConditions;